module.exports = __webpack_public_path__ + "static/media/photo_camera.138cd54e.png";